/**
 * Возвращает округленное значение под текущий DPR экрана пользователя
 *
 * Учитывает DPI и подгоняет под пиксели экрана
 *
 * Зачем нужно:
 * Часто пиксели браузера могут несовпасть с пикселями экрана, и в случае если у пользователя
 * низкий DPI это становится заметно, элемент "размывает".
 * И чтобы этого избежать реализована данная функция, она помогает посчитать какой пиксель браузера указать,
 * чтобы попасть точно в пиксель экрана пользователя
 *
 * Обычно используется для определения transform отступов
 *
 * @param value - значение для округления
 * @returns Дробное число, округленное под текущий DPR
 */
export function roundByDPR(value: number) {
    const dpr = typeof window !== 'undefined' ? window.devicePixelRatio : 1;
    return Math.round(value * dpr) / dpr;
}
